export default __webpack_public_path__ + "2c4c440a2b5dc4f459101a81ebbaafbf.png";